import { render, staticRenderFns } from "./Codepen.vue?vue&type=template&id=2bb93fc7&scoped=true&"
import script from "./Codepen.vue?vue&type=script&setup=true&lang=js&"
export * from "./Codepen.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb93fc7",
  null
  
)

export default component.exports